import "../styles/main.sass";

import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/regular";
import "@fortawesome/fontawesome-free/js/brands";

import "./bootstrap.config";

import Quagga from "@ericblade/quagga2";

import Chart from "chart.js/auto";

// import and register htmx to the window element
import htmx from "htmx.org";
window.htmx = htmx;

function run() {
    window.addEventListener("load", function () {
        const cartByTimeCharts = document.querySelectorAll(".cartByTimeChart");
        cartByTimeCharts.forEach(function (element) {
            const chartData = JSON.parse(
                document.getElementById(element.dataset.dataElement).textContent
            );
            const xAxisKey = element.dataset.xAxisKey || "hour";
            const yAxisKey = element.dataset.yAxisKey || "count";
            const xAxisType = element.dataset.xAxisType || "linear";
            const chartType = element.dataset.chartType || "bar";

            let datasets = [];
            if (chartData.current) {
                datasets.push({
                    label: chartData.current_label || "Current",
                    data: chartData.current,
                    borderColor: "rgb(16,181,181)",
                    backgroundColor: "rgba(16,181,181,0.8)",
                });

                const comparisonColors = [
                    {
                        // Previous: different color, slightly gray shaded, darker
                        border: "rgba(168,150,131,0.8)",
                        background: "rgba(168,150,131, 0.6)",
                    },
                    {
                        // Previous-Previous: variant of first color, darker and same tone
                        border: "rgba(115, 175, 175, 0.8)",
                        background: "rgba(115, 175, 175, 0.6)",
                    },
                ];

                if (chartData.comparison && chartData.comparison.length > 0) {
                    chartData.comparison.forEach((comp, index) => {
                        const color =
                            comparisonColors[index % comparisonColors.length];
                        datasets.push({
                            label: comp.label,
                            data: comp.data,
                            borderColor: color.border,
                            backgroundColor: color.background,
                        });
                    });
                }
            } else {
                datasets.push({
                    data: chartData,
                });
            }

            new Chart(element, {
                type: chartType,
                data: {
                    datasets: datasets,
                },
                options: {
                    parsing: {
                        xAxisKey: xAxisKey,
                        yAxisKey: yAxisKey,
                    },
                    plugins: { legend: { display: datasets.length > 1 } },
                    scales: {
                        y: {
                            beginAtZero: true,
                            ticks: {
                                precision: ["count", "carts", "items"].includes(
                                    yAxisKey
                                )
                                    ? 0
                                    : 2,
                            },
                        },
                        x: {
                            type: xAxisType,
                            min: xAxisType === "linear" ? 0 : undefined,
                            max: xAxisType === "linear" ? 23 : undefined,
                            ticks: {
                                stepSize: 1,
                            },
                        },
                    },
                },
            });
        });

        const autoselectInputs = document.querySelectorAll(
            '*[data-autoselect="true"]'
        );
        autoselectInputs.forEach(function (input) {
            input.addEventListener("focus", function (event) {
                event.target.select();
            });
        });

        const searchClearButtons = document.querySelectorAll(
            ".search-input-clear"
        );
        searchClearButtons.forEach(function (button) {
            const input = button.parentElement.querySelector("input");
            function toggleClearButton() {
                button.hidden = !input.value;
            }
            toggleClearButton();
            input.addEventListener("input", toggleClearButton);
            button.addEventListener("click", function () {
                input.value = "";
                input.focus();
                toggleClearButton();
            });
        });

        const toggleBarcodeScanner = document.querySelectorAll(
            '*[data-toggle="barcode-scanner"]'
        );
        toggleBarcodeScanner.forEach(function (button) {
            if (
                navigator.mediaDevices &&
                typeof navigator.mediaDevices.getUserMedia === "function"
            ) {
                button.addEventListener("click", function (event) {
                    if (isScanActive === false) {
                        startBarcodeScanner(button);
                    } else {
                        stopBarcodeScanner();
                    }
                    event.preventDefault();
                    return false;
                });
            } else {
                button.disabled = true;
            }
        });
    });
}

let isScanActive = false;

function stopBarcodeScanner() {
    Quagga.stop();
    isScanActive = false;
}

function startBarcodeScanner(button) {
    Quagga.init(
        {
            debug: false,
            inputStream: {
                name: "Live",
                type: "LiveStream",
                target: document.querySelector("#barcode-scanner-viewport"),
                constraints: {
                    width: 1280,
                    height: 720,
                    facingMode: "environment",
                },
                area: {
                    top: "0%",
                    right: "0%",
                    left: "0%",
                    bottom: "0%",
                },
            },
            decoder: {
                readers: ["code_128_reader"],
                multiple: false,
            },
            locator: {
                halfSample: true,
                patchSize: "large",
            },
        },
        function (err) {
            if (err) {
                console.error(err);
                return;
            }

            Quagga.start();

            const track = Quagga.CameraAccess.getActiveTrack();
            let capabilities = {};
            if (track && typeof track.getCapabilities === "function") {
                capabilities = track.getCapabilities();
            }

            const toggleTorch = document.querySelectorAll(
                '*[data-toggle="torch"]'
            );
            toggleTorch.forEach(function (button) {
                if (capabilities.torch) {
                    button.removeAttribute("disabled");
                }
                button.addEventListener("click", function (event) {
                    const setting = track.getSettings();
                    if (capabilities.torch) {
                        track.applyConstraints({
                            advanced: [{ torch: !setting.torch }],
                        });
                    }
                });
            });
        }
    );

    const resultInput = document.querySelector(button.dataset.resultTarget);
    const form = resultInput.closest("form");
    Quagga.onDetected(function (result) {
        const code = result.codeResult.code;
        stopBarcodeScanner();
        resultInput.value = code;
        form.submit();
    });
}

run();
